// extracted by mini-css-extract-plugin
module.exports = {"wrap":"result_wrap__aAcah","card":"result_card__1hxwC","card_inner":"result_card_inner__1_KoZ","card_footer":"result_card_footer__1IQXK","text":"result_text__31GxJ"};